export default "__VITE_ASSET__seFcz7fu__"